import { queryOptions } from "@react/foundation/query";

import type { GridEpochId } from "@apis/calorie-grid/models";

import { epochRepository } from "../../repository/EpochRepository.ts";
import { gridConfigRepository } from "../../repository/GridConfigRepository.ts";
import { useAuth } from "../contexts/auth/useAuth.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useUnconfiguredQueries() {
  const { userId } = useAuth();

  return {
    getEpochQueryOptions: queryOptions({
      queryFn: async () => epochRepository.getById({ userId }),
      queryKey: { group: () => ["epochRepository.getById", userId] },
    }),
    getGridConfigQueryOptions: queryOptions({
      queryFn: async (gridEpochId: GridEpochId) =>
        gridConfigRepository.getById({ gridEpochId, userId }),
      queryKey: {
        group: gridEpochId => [
          "gridConfigRepository.getById",
          userId,
          gridEpochId,
        ],
      },
    }),
  };
}
